import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-view',
  templateUrl: './help-view.component.html',
  styleUrls: ['./help-view.component.scss']
})
export class HelpViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
